// extracted by mini-css-extract-plugin
module.exports = {"ratesTable":"Mwyfs8woS-Pay0VnJw846","ratesH":"_1y8U_5lJNuVB63NR_6Foih","rateCol":"pfKrvlMsvN8XqAZ68xBU-","seasonLabel":"H4FAF0UDJh3P4vffdEoL_"};